
          import "Password_rssvu5.linaria.css";
          import React, { PureComponent } from "react";
import { string, ref } from "yup";
import { styled } from "@linaria/react";
import Input from "./Base";
export const PasswordToggler = /*#__PURE__*/styled("div")({
  name: "PasswordToggler",
  class: "p1eprb63"
});
const StyledPasswordInput = /*#__PURE__*/styled(Input)({
  name: "StyledPasswordInput",
  class: "sy5hp0d"
});
export const schema = {
  create: string().required("A password is required").min(8, "Password must be a minimum of 8 characters"),
  confirm: passwordRef => string().required("Passwords must match").oneOf([ref(passwordRef), null], "Passwords must match"),
  login: string().required("A password is required")
};

class PasswordInput extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showPassword: false
    };
    this.togglePasswordHiddenState = this.togglePasswordHiddenState.bind(this);
  }

  togglePasswordHiddenState() {
    const {
      showPassword
    } = this.state;
    this.setState({
      showPassword: !showPassword
    });
  }

  render() {
    const {
      showPassword
    } = this.state;
    const {
      id,
      className,
      description,
      ...restProps
    } = this.props;
    return /* @__PURE__ */React.createElement(StyledPasswordInput, {
      id,
      type: showPassword ? "text" : "password",
      label: "Password",
      className,
      required: true,
      maxLength: 128,
      description,
      ...restProps
    }, /* @__PURE__ */React.createElement(PasswordToggler, {
      onClick: this.togglePasswordHiddenState,
      "data-testid": "password-toggler"
    }, showPassword ? "Hide" : "Show"));
  }

}

PasswordInput.defaultProps = {
  className: ""
};
export default PasswordInput;
          